import React, { useState, useRef } from 'react'
import type { ValueDisplayResult } from '../utils/odds'
import { getEdgeColorClass } from '../utils/odds'

interface EdgeBadgeProps {
  value: ValueDisplayResult
  ourProbability: number
  bookmakerName?: string
}

export function EdgeBadge({ value, ourProbability, bookmakerName }: EdgeBadgeProps) {
  const [showTooltip, setShowTooltip] = useState(false)
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 })
  const badgeRef = useRef<HTMLSpanElement>(null)

  const colorClass = getEdgeColorClass(value.edge)
  const isPositive = value.edge > 0

  const handleMouseEnter = () => {
    if (badgeRef.current) {
      const rect = badgeRef.current.getBoundingClientRect()
      // Position tooltip above the badge, centered
      setTooltipPos({
        top: rect.top - 8, // 8px gap above
        left: rect.left + rect.width / 2,
      })
    }
    setShowTooltip(true)
  }

  return (
    <span
      ref={badgeRef}
      className={`edge-badge ${colorClass}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShowTooltip(false)}
      style={{ cursor: 'help' }}
    >
      {value.edgeLabel}
      {showTooltip && (
        <div
          className="edge-tooltip"
          style={{
            top: tooltipPos.top,
            left: tooltipPos.left,
            transform: 'translate(-50%, -100%)',
          }}
        >
          <div className="edge-tooltip-header">
            {isPositive ? 'Value Bet' : 'Negative Edge'}
          </div>
          <div className="edge-tooltip-row">
            <span className="edge-tooltip-label">Your probability</span>
            <span className="edge-tooltip-value">{ourProbability.toFixed(1)}%</span>
          </div>
          <div className="edge-tooltip-row">
            <span className="edge-tooltip-label">Implied probability</span>
            <span className="edge-tooltip-value">{value.impliedProbability.toFixed(1)}%</span>
          </div>
          <div className="edge-tooltip-row edge-tooltip-edge">
            <span className="edge-tooltip-label">Edge</span>
            <span className={`edge-tooltip-value ${colorClass}`}>{value.edgeLabel}</span>
          </div>
          {bookmakerName && (
            <div className="edge-tooltip-bookmaker">
              {bookmakerName}
            </div>
          )}
        </div>
      )}
    </span>
  )
}
